import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CurrentUserDetailsResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/useApiClient.util.ts';

type Return = {
  currentUser: CurrentUserDetailsResponseDto | undefined;
  error: AxiosError;
  isErrorGettingCurrentUser: boolean;
  isGettingCurrentUser: boolean;
};

export const useGetCurrentUser = (): Return => {
  const { currentUserApi } = useApiClient();
  const { data, error, fetchStatus, isError, isLoading } = useQuery<
    CurrentUserDetailsResponseDto,
    AxiosError
  >({
    enabled: true,
    queryFn: async () => {
      const response = await currentUserApi.getCurrentUserDetails();
      return response?.data;
    },
    queryKey: [QueryKeyEnum.CURRENT_USER],
  });
  return {
    currentUser: data,
    error: error ?? ({} as AxiosError),
    isErrorGettingCurrentUser: isError,
    isGettingCurrentUser: fetchStatus !== 'idle' && isLoading,
  };
};
